import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment'
import { Result } from '../../shared/result';

import { tap, map, catchError } from 'rxjs/operators';
import {  StateMasterFilterModel  } from '../fare-component/Model/FareComponent-master';


const CREATE_ACTION = 'InsertFareComponentTypeMaster';
const UPDATE_ACTION = 'UpdateFareComponentTypeMaster';
const GET_ACTION = 'GetFareComponentTypeMaster';


@Injectable({
  providedIn: 'root'
})
export class FareComponentTypeGridService extends BehaviorSubject<any[]> {

  OPRSAPIUrl:string;

    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8'
        })
      };

  constructor(private http: HttpClient) {
      super([]);
      this.OPRSAPIUrl=environment.OPRSAPIUrl;
  }

  private data: any[] = [];

private handleError(err: HttpErrorResponse) {
let errorMessage = '';
if (err.error instanceof ErrorEvent) {
  errorMessage = `An error occurred: ${err.error.message}`;
} else {
  errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
}
console.error(errorMessage);
return throwError(errorMessage);
}


  // public GetFareComponentTypeMaster(data:any) {
  //   return this.http.post<Result>(`${this.OPRSAPIUrl}/Fare/GetFareComponentTypeMaster`,data, this.httpOptions);
  // }

  // public InsertandUpdateFareComponentTypeMaster(data:any) {
  //   return this.http.post<Result>(`${this.OPRSAPIUrl}/Fare/InsertandUpdateFareComponentTypeMaster`,data, this.httpOptions);
  // }

  public GetMathOperatorType() {

    return this.http.post<Result>(`${environment.apiUrl}/Fare/GetFareOperationTypeMaster`, this.httpOptions);
  }

  public GetFareComponentMaster(data:any) {
    debugger
    return this.http.post<Result>(`${environment.apiUrl}/Fare/GetFareComponentMaster`,data, this.httpOptions);
  }


  public GetFareComponentTypeMaster(data:any)
  {
    return this.http.post<Result>(environment.apiUrl + "/Fare/GetFareComponentTypeMaster", data);
  }
  public GetFareOperationTypeMaster(data:any)
  {
    return this.http.post<Result>(environment.apiUrl + "/Fare/GetFareOperationTypeMaster", data);
  }
  public GetRegionalLanguageMaster(data:any)
  {
    return this.http.post<Result>(environment.apiUrl + "/Common/GetRegionalLanguageMaster", data);
  }
  
  public InsertandUpdateFareComponentTypeMaster(data:any)
    {
      return this.http.post<Result>(environment.apiUrl + "/Fare/InsertandUpdateFareComponentTypeMaster", data);
    }
  

  public getRegionalLanguage1() {
      return this.http.post<Result>(`${environment.apiUrl}/Common/GetRegionalLanguageMaster`, '')
        .pipe(map(value => {
          return value;
        }));
  }





}
